export function getValueFromMap<TKey, TValue>(
    map: Map<TKey, TValue>,
    key: TKey
): TValue {
    const value = map.get(key);

    if (!value) {
        const validKeys = [...map.keys()];
        throw new Error(
            `Invalid key passed to getValueFromMap. "${key}" does not exist in valid keys: ${validKeys}`
        );
    }

    return value;
}
